import React from 'react';

export default function bindPropsHOF(bindedProps) {
  return function bindPropsHOC(Component) {
    function BindedComponent(props) {
      return <Component {...props} {...bindedProps} />;
    }

    // Указываем оригинальный компонент.
    BindedComponent.WrappedComponent = Component;

    /**
     * Если передана карточка, то прокидываем значение ее статического
     * свойства `requiredPayloadImports` в HOC.
     */
    if (Component.requiredPayloadImports) {
      BindedComponent.requiredPayloadImports = Component.requiredPayloadImports;
    }

    /**
     * Если передана карточка, то прокидываем значение ее статического
     * свойства `requiredPayloadFields` в HOC.
     */

    if (Component.requiredPayloadFields) {
      BindedComponent.requiredPayloadFields = Component.requiredPayloadFields;
    }

    return BindedComponent;
  };
}
